import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows } from 'store/redux-store/placement-mods/selectors';
import { GridCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { getExistingRow, getNewRow } from './TimeOffHours';

interface GridCellProps {
  [key: string]: any;
}

export const FacilityApprovedCell = (cellParams: GridCellParams) => {
  return <FacilityApproved cellParams={cellParams} />;
};

const FacilityApproved = React.memo(function FacilityApproved(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const [facilityApproved, setFacilityApprovedHours] = useState(cellParams?.cellParams?.row?.facilityApprovedBy);
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const { control } = useFormContext();
  const RowId = cellParams?.cellParams?.id;

  const setFacilityApprovedEdit = data => {
    let newRow = timeOffEditRequests.slice(0);

    let timeOffEditRow = cellParams?.cellParams?.row?.placementTimeOffId
      ? getExistingRow(timeOffEditRequests, cellParams)
      : getNewRow(timeOffEditRequests, RowId);

    let updateFacility = { ...timeOffEditRow, facilityApprovedBy: data };
    let editDateIndex = timeOffEditRequests?.findIndex(
      cellParams?.cellParams?.row?.placementTimeOffId
        ? row => row.placementTimeOffId === updateFacility.placementTimeOffId
        : row => row.id === RowId,
    );
    newRow[editDateIndex] = updateFacility;
    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  return (
    <>
      <Controller
        name={`timeOffRequests${RowId}.facilityApprovedBy`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            variant="outlined"
            size={'small'}
            style={{ width: '150px' }}
            value={facilityApproved}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setFacilityApprovedEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setFacilityApprovedHours(e.target.value);
              } else {
                setFacilityApprovedHours('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
